import { AccessRights, UserUpdateViewModel } from "app/services/users.service";
import { UsersDialogBaseComponent } from "./users-dialog-base/users-dialog-base.component";
import { Component, Injector } from "@angular/core";

@Component({
  selector: 'app-edit-user',
  templateUrl: './users-dialog-base/users-dialog-base.component.html',
  styleUrls: ['./users-dialog-base/users-dialog-base.component.css'],
  standalone: false
})
export class EditUserComponent extends UsersDialogBaseComponent<UserUpdateViewModel> {
  constructor(protected injector: Injector) {
    super(injector);
    this.dialogId = "editUser";
  }

  public submit() {

    this.usersService.updateUser(this.buildSubmitModel())
      .subscribe((res) => {
        this.onCreated.emit();
        this.close();
        super.submit();

      });
  }
}
